import { render, staticRenderFns } from "./PricingTariffsSlider.vue?vue&type=template&id=4e537fd1"
import script from "./PricingTariffsSlider.vue?vue&type=script&lang=js"
export * from "./PricingTariffsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports